import { Divider } from "@mui/material";
import BasicTable from "components/common/Table";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { PAGE_SIZE } from "utils/CommonConstants";
import { fetchUnImplementedProperties } from "../../AboveProperty.slice";
import FilterButtons from "../../FilterButtons";
import { headers } from "./TableHeadersConfig";

interface Props {
  toggleOn?: boolean;
  handleToggle: any;
  cmsId: any;
}

function UnImplementedProperties(props: Props) {
  const { handleToggle, toggleOn, cmsId } = props;

  const dispatch = useAppDispatch();
  const [pageNo, setPageNo] = useState(0);
  const { unImplementedProperties, unImplemenetedCount } = useAppSelector((state) => state.aboveProperty.planProgress);
  const { searchText, inncode } = useAppSelector(
    (state: any) => state.aboveProperty.filters.planViewFilters.unImplementedFilters
  );
  const location = useLocation();

  const apiCall = () => {
    const props = {
      innCode: inncode?.length ? inncode.join(",") : location?.state?.progressInncodes?.join(", "),
      searchedPropertyText: searchText,
      size: PAGE_SIZE,
      page: pageNo,
      cmsId: cmsId
    };

    if (!toggleOn) dispatch(fetchUnImplementedProperties(props));
  };

  useEffect(() => {
    if (pageNo === 0) {
      apiCall();
    }
  }, [pageNo, searchText, inncode]);

  useEffect(() => {
    setPageNo(0);
  }, [searchText, inncode]);

  useEffect(() => {
    if (pageNo > 0) {
      apiCall();
    }
  }, [pageNo]);

  return (
    <>
      <FilterButtons
        isToggleVisible
        toggleOnChange={(val: boolean) => {
          handleToggle(val);
        }}
        isToggleEnabled={false}
        isInncodeVisible
        optionsList={{ inncode: location?.state?.progressInncodes }}
        isSearchBarVisible
        parentView="planViewFilters"
        filterType="unImplementedFilters"
        searchBarPlaceHolder="Search by property"
      />
      <Divider />
      <BasicTable
        id="tableDiv"
        totalRecords={unImplemenetedCount}
        pagination={{ pageNo: pageNo, setPageNo: setPageNo }}
        data={{
          headers,
          rows: unImplementedProperties?.map((element: any) => {
            return {
              data: [
                {
                  content: element?.propertyName
                },
                { content: element?.innCode },
                { content: "-" },
                { content: "-" },
                { content: "-" },
                { content: "-" },
                { content: "-" },
                { content: "-" }
              ]
            };
          })
        }}
      />
    </>
  );
}

export default UnImplementedProperties;
